import { saveAs } from 'file-saver'

/**
 * Permer d'exporter des données sur un fichier
 */
class FileExporter {
  /**
     * Exporter des données dans un fichier
     * @param {*} data données
     * @param {*} filename nom du fichier
    */
  export(data, filename) {
    // fichier csv
    let csvHeaders = []
    let csvData = []

    Object.keys(data).map((header) => {
      csvHeaders.push(header)
    })

    Object.values(data).map((item) => {
      csvData.push(item)
    })

    // ajout des données
    let csvContent = [
      csvHeaders.join(','),
      csvData.join(',')
    ].join('\n')
    // Création
    let file = new File([csvContent], filename, { type: 'text/csv;charset=utf-8' })
    // Télecharger
    saveAs(file)
  }
  /**
   * Exporter des données dans un fichier sans extraire le header
   * @param {} data données
   * @param {*} filename nom de fichier
   */
  exportFromData(data, filename) {
    let file = new File([data], filename, { type: 'text/csv;charset=utf-8' })
    // Télecharger
    saveAs(file)
  }
}

export default FileExporter
